export var ContactStrings = {
    title: 'Contato',
};
